import { OrderStatus } from '@customTypes/order';

export const ORDER_STATUS_MAPPING: {
  [key in OrderStatus]: {
    weight: number;
    label: string;
  };
} = {
  DENIED: {
    weight: 1,
    label: 'Denied',
  },
  FAILED: {
    weight: 2,
    label: 'Failed',
  },
  SUBMITTED: {
    weight: 3,
    label: 'Processing',
  },
  APPROVED: {
    weight: 4,
    label: 'Processing',
  },
  AWAITING_SAMPLE: {
    weight: 5,
    label: 'Awaiting Sample',
  },
  ANALYZING: {
    weight: 6,
    label: 'Analyzing',
  },
  REFERRAL_LAB_LD_REVIEW: {
    weight: 7,
    label: 'Analyzing',
  },
  CLINICIAN_REVIEW: {
    weight: 8,
    label: 'Clinician Review',
  },
  COMPLETED: {
    weight: 9,
    label: 'Reported',
  },
  REPORTED: {
    weight: 10,
    label: 'Reported',
  },
  CANCELED: {
    weight: 11,
    label: 'Canceled',
  },
};

export const COMPLETED_ORDER_STATUSES = [OrderStatus.COMPLETED, OrderStatus.REPORTED];
